
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class SlotWithConfirm extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: Boolean, default: true }) readonly valid!: boolean

  isConfirmed = false

  created() {
    console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console
    this.isConfirmed = this.value;
  }

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange(${val})`); // eslint-disable-line no-console
    this.isConfirmed = val;
    this.$emit('input', val);
  }

  @Watch('isConfirmed')
  onIsConfirmedChange(val: boolean) {
    console.log(`${this.constructor.name}: onIsConfirmedChange(${val})`); // eslint-disable-line no-console
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lineClass(): string {
    return this.isConfirmed ? 'selected' : '';
  }

  get tooltipText(): string {
    if (this.valid === true) {
      return this.isConfirmed ? 'Confermato' : 'Premi per confermare';
    }

    return 'Non confermato';
  }
}

